import {createStore, applyMiddleware} from 'redux';
import thunkMiddleware from 'redux-thunk';
import promiseMiddleware from 'redux-promise-middleware';
import {composeWithDevTools} from 'redux-devtools-extension';
import rootReducer from './reducers';
import SentryUtils from '@livongo/utils/sentry';
import {PII_STATE_EXCLUSIONS} from 'user/user-reducer';
import omit from 'lodash/omit';

let store;

export default function create(initialState) {
    const sentryReduxEnhancer = SentryUtils.createReduxEnhancer({
        actionTransformer: action => {
            return action;
        },
        stateTransformer: state => {
            return {
                ...state,
                user: omit(state.user, PII_STATE_EXCLUSIONS),
            };
        },
    });

    store = createStore(
        rootReducer,
        initialState,
        composeWithDevTools(
            applyMiddleware(thunkMiddleware, promiseMiddleware),
            ...(sentryReduxEnhancer ? [sentryReduxEnhancer] : [])
        )
    );

    return store;
}

export const getStore = () => {
    return store;
};
